// Kiss of Judas helpers. Pure. No React, no Three.js.
//
// ── Rules text ──
//   "This turn, attacks against target Avatar can't be defended and you
//    draw a card whenever they are attacked."
//
// Wiring overview (the runtime threads these together):
//   1. The spell targets an Avatar and marks it for the turn with the
//      `judas_marked` status (rides the existing card:status broadcast,
//      so the host that resolves combat sees the mark). The caster seat
//      is stamped on the card so the host knows who draws.
//   2. `getEligibleDefenders` reads `isUndefendable` and offers no
//      defenders. The attack can't be defended (mirror of Stealth).
//   3. When the marked Avatar is attacked, the caster draws a card
//      (resolved inline from the on_attack combat hook).
//
// The mark and the caster stamp clear at the end of the caster's turn
// (same end-phase prune pass that drops other this-turn flags).

export const JUDAS_MARK = 'judas_marked';

/**
 * True iff this card carries Kiss of Judas's this-turn mark, so attacks
 * against it can't be defended. Read by getEligibleDefenders.
 *
 * @param card the would-be attack target
 * @returns {boolean}
 */
export function isUndefendable(card) {
  return !!card && Array.isArray(card.statuses) && card.statuses.includes(JUDAS_MARK);
}

/**
 * The seat that drew the card via Kiss of Judas's "you draw" clause when
 * the marked Avatar is attacked. Stamped at cast time (`_judasCaster`);
 * falls back to the opponent of the marked Avatar's controller, the only
 * meaningful caster in normal play.
 *
 * @param card the marked Avatar
 * @returns {'p1' | 'p2'}
 */
export function judasDrawRecipient(card) {
  if (card?._judasCaster === 'p1' || card?._judasCaster === 'p2') return card._judasCaster;
  return card?.rotated ? 'p1' : 'p2';
}
